import { useState } from "react";
import { useTranslation } from "react-i18next";
import { locales } from "~/i18n/config";
import { ChevronDownIcon, GlobeIcon } from "~/components/common/icons";

/**
 * Language switcher. Switches the in-memory i18n instance client-side
 * (updates the UI live for the session). Server locale still derives from the
 * Accept-Language header on the next full load.
 */
export const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = (i18n.language || "en").split("-")[0];

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-1 rounded-lg px-2 py-1.5 text-sm font-medium text-text-medium transition hover:bg-surface-elevated hover:text-text-full"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <GlobeIcon className="h-4 w-4" />
        <span className="uppercase">{current}</span>
        <ChevronDownIcon className="h-3 w-3" />
      </button>

      {open && (
        <>
          <button
            type="button"
            aria-label="Close"
            className="fixed inset-0 z-40 cursor-default"
            onClick={() => setOpen(false)}
          />
          <ul
            role="listbox"
            className="absolute right-0 z-50 mt-1 min-w-[6rem] overflow-hidden rounded-lg border border-border-shell bg-surface-blank py-1 shadow-content"
          >
            {locales.map(locale => (
              <li key={locale}>
                <button
                  type="button"
                  role="option"
                  aria-selected={locale === current}
                  onClick={() => {
                    i18n.changeLanguage(locale);
                    setOpen(false);
                  }}
                  className={`block w-full px-4 py-1.5 text-left text-sm transition hover:bg-surface-elevated ${
                    locale === current
                      ? "font-semibold text-accent"
                      : "text-text-medium"
                  }`}
                >
                  {locale.toUpperCase()}
                </button>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};
